<template>
    <div v-show="videoData != null">
        <template v-if="videoData?.type === 'youtube'">
            <iframe
                class="youtube-iframe"
                :src="`https://www.youtube-nocookie.com/embed/${videoData.id}?fs=0&iv_load_policy=3&rel=0`"
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
            ></iframe>
        </template>
    </div>
</template>

<style scoped lang="scss">
.youtube-iframe {
    width: 100%;
    aspect-ratio: 560/315;
    max-width: 560px;
}
</style>

<script setup lang="ts">
import { computed } from "vue";
import { parseVideoData } from "./video-data";

const props = defineProps({
    videoLink: String,
});

const videoData = computed(() => {
    return parseVideoData(props.videoLink);
});
</script>
